var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-view"},_vm._l((5),function(i){return _c('div',{key:i,staticClass:"rating",class:{
        fill: i <= _vm.ratingInt,
        'not-filled': i > _vm.ratingInt,
        small: _vm.isSmall
      }},[(i > _vm.ratingInt && _vm.widthPercent)?_c('div',{staticClass:"rating fill half",class:{ small: _vm.isSmall },style:(("width: " + _vm.widthPercent + "%"))}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }